import request from '@/utils/request'
import authData from '@/api/authConfig'


export function loginByUsername(username, password) {
  const params = Object.assign(authData, {grant_type: 'password', username, password})
  return request({
    url: '/oauth/v2/token',
    method: 'get',
    params
  })
}

export function refreshToken(refresh_token) {
  const params = Object.assign(authData, {grant_type: 'refresh_token', refresh_token})
  return request({
    url: '/oauth/v2/token',
    method: 'get',
    params
  })
}

export function logout() {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  return request({
    url: '/api/users/current',
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js